import api from './client';

export const salidasApi = {
  listar: (params) => api.get('/salidas', { params }),
  obtener: (id) => api.get(`/salidas/${id}`),
  crear: (data) => api.post('/salidas', data),
  agregarDocumento: (id, data) => api.post(`/salidas/${id}/documentos`, data),
  quitarDocumento: (salidaId, docId) => api.delete(`/salidas/${salidaId}/documentos/${docId}`),
  despachar: (id) => api.post(`/salidas/${id}/despachar`),
  // Entregar antes de la fecha pactada = OK del vendedor (30 oct 2026)
  verificarAnticipadas: (data) => api.post('/entregas-anticipadas/verificar', data),
  pedirAnticipada: (data) => api.post('/entregas-anticipadas', data),
  resolverAnticipada: (id, estado) => api.post(`/entregas-anticipadas/${id}/resolver`, { estado }),
  cerrar: (id) => api.post(`/salidas/${id}/cerrar`),
  // Mapa de reparto: última ubicación de cada camioneta en la calle.
  ubicaciones: () => api.get('/salidas-ubicaciones'),
  // Andreani en lote + costo de la salida (Martin, 3 oct 2026).
  cotizarAndreani: (documentos) => api.post('/salidas/cotizar-andreani', { documentos }),
  cotizacionAndreani: (id) => api.get(`/salidas/${id}/andreani/cotizacion`),
  generarAndreani: (id, body = null) => api.post(`/salidas/${id}/andreani/generar`, body, { timeout: 300000 }),
  etiquetasAndreani: (id) => api.get(`/salidas/${id}/andreani/etiquetas`, { responseType: 'blob', timeout: 180000 }),
  guardarCosto: (id, costo) => api.put(`/salidas/${id}/costo`, { costo }),
};

export const salidaDocumentosApi = {
  entregar: (id, data) => api.post(`/salida-documentos/${id}/entregar`, data),
  noEntregar: (id, data) => api.post(`/salida-documentos/${id}/no-entregar`, data),
  reagendar: (id, data) => api.post(`/salida-documentos/${id}/reagendar`, data),
  revertirEntrega: (id) => api.post(`/salida-documentos/${id}/revertir-entrega`),
  // Sug #60: logística adjunta el remito FIRMADO que volvió en papel, con la
  // entrega ya marcada (el respaldo documental no depende del momento).
  subirImagenes: (salidaId, docId, imagenes) =>
    api.post(`/salidas/${salidaId}/documentos/${docId}/imagenes`, { imagenes }),
};

export const salidaPublicaApi = {
  obtener: (token) => api.get(`/publico/salidas/${token}`),
  entregar: (token, docId, data) =>
    api.post(`/publico/salidas/${token}/documentos/${docId}/entregar`, data),
  noEntregar: (token, docId, data) =>
    api.post(`/publico/salidas/${token}/documentos/${docId}/no-entregar`, data),
  reagendar: (token, docId, data) =>
    api.post(`/publico/salidas/${token}/documentos/${docId}/reagendar`, data),
  revertirEntrega: (token, docId) =>
    api.post(`/publico/salidas/${token}/documentos/${docId}/revertir-entrega`),
  // El fletero reconoce una parada que el CLIENTE reprogramó (botón rojo)
  reagendoVisto: (token, docId) =>
    api.post(`/publico/salidas/${token}/documentos/${docId}/reagendo-visto`),
  subirImagenes: (token, docId, imagenes) =>
    api.post(`/publico/salidas/${token}/documentos/${docId}/imagenes`, { imagenes }),
  reordenar: (token, ids) =>
    api.post(`/publico/salidas/${token}/documentos/reordenar`, { ids }),
  ubicacion: (token, data) =>
    api.post(`/publico/salidas/${token}/ubicacion`, data),
};
